import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 0H3C1.3 0 0 1.271 0 2.933v13.686c0 1.662 1.3 2.933 3 2.933h14c1.7 0 3-1.271 3-2.933V2.933C20 1.271 18.7 0 17 0M2 2.933c0-.587.4-.978 1-.978h14c.6 0 1 .391 1 .978v7.43l-3.3-3.227a.98.98 0 0 0-1.4 0L2.7 17.499a.94.94 0 0 1-.7-.88zm15 14.664H5.4L14 9.19l4 3.91v3.52c0 .586-.4.977-1 .977M6.5 8.798c1.4 0 2.5-1.075 2.5-2.443 0-1.37-1.1-2.444-2.5-2.444S4 4.986 4 6.355s1.1 2.444 2.5 2.444zm0-2.932c.3 0 .5.195.5.489 0 .293-.2.488-.5.488S6 6.648 6 6.356c0-.294.2-.49.5-.49"
    }, null, -1)
  ]))]))
}
export default { render: render }